<template>
  <div class="sales-chart pl-5">

    <!-- <div class="d-flex align-items-center justify-content-between mb-3">
      <div>
        <h3 class="text-dark font-size-secondary mb-2">{{$t('dashboard.resourceUsage')}}</h3>

        <div class="small-info">
          <b>$ 000</b> lorem ipsum
        </div>
      </div>
      <div class="d-flex">
        <div class="text-right">
          <div>
            $315
          </div>
          <span class="small-info-2">
            <i class="fas fa-circle fa-sm text-danger mx-2"></i>{{$t('targeted')}}
          </span>
        </div>
        <div class="text-right ml-5">
          <div>
            $945
          </div>
          <span class="small-info-2">
            <i class="fas fa-circle fa-sm text-primary mx-2"></i>{{$t('happening')}}
          </span>
        </div>
      </div>
    </div> -->

    <apexchart :options="chartOptions"
               :series="series"
               type="area"></apexchart>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SalesChart',
  props: {
    filters: '',
    selectedMonth: '',
  },
  data() {
    return {
      chartOptions: {},
      series: [
        {
          name: 'RAM',
          data: [0, 2, 2, 5, 7, 3],
        },
        {
          name: 'CPU',
          data: [0, 1, 1, 3, 5, 0],
        }
      ],
    }
  },
  created() {
    this.setChart()
  },
  computed: {
    ...mapGetters(['layoutConfig']),
  },
  mounted() {
    this.chartOptions = {
      chart: {
        type: 'area',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        sparkline: {
          enabled: true,
        },
        height: 280,
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'solid',
        opacity: 1,
      },
      stroke: {
        curve: 'smooth',
        show: true,
        width: 3,
        colors: ['#AEEEEB', '#FFEBC2'],
      },
      xaxis: {
        show: false,
      },
      yaxis: {
        show: false,
        min: 0,
        // max: function (max) {
        //   return max + 1
        // },
      },
      tooltip: {
        style: {
          fontSize: '12px',
          fontFamily: this.layoutConfig('font-family'),
        },
      },
      colors: ['#AEEEEB', '#FFEBC2'],
      grid: {
        show: false,
        padding: {
          left: 0,
          right: 0,
        },
      },
    }
  },
  methods: {
    setChart() {
      // console.log('saleschart.filters :>> ', this.filters)
      // console.log('saleschart.selectedMonth :>> ', this.selectedMonth)
    },
  },
  watch: {
    filters() {
      this.setChart()
    },
    selectedMonth() {
      this.setChart()
    },
  },
}
</script>

<style lang="scss">
.sales-chart {
  .small-info {
    font-style: normal;
    font-size: 15px;
    line-height: 22px;

    color: #80808f;
  }
  .small-info-2 {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #80808f;
  }
}
</style>
